<template>
  <div class="service-record-description">
    <div class="service-record-description__section">
      <div class="service-record-description__title-section">
        <div class="service-record-description__label">Beskrivelse</div>
      </div>
      <div class="service-record-description__border" />
      <div class="service-record-description__value">
        {{ description || "Ingen beskrivelse tilgjengelig" }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  description?: string;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.service-record-description {
  margin-bottom: 1rem;

  &__section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
  }

  &__title-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  &__label {
    font-size: $font-size-base;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    color: $color-primary;
    font-weight: 600;
  }

  &__border {
    align-self: stretch;
    position: relative;
    background-color: $color-primary-light;
    height: 1px;
  }

  &__value {
    align-self: stretch;
    position: relative;
    font-size: $font-size-base;
    color: $color-primary-darker;
    font-weight: 400;
    line-height: 1.5;
  }
}
</style>
